export default __webpack_public_path__ + "static/media/messenger.a5312252.svg";